/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import { getSvgIcon } from 'resources';
import AppStyle from 'scss/main/App.module.scss';
import { Action } from 'store/slices';
import { RootState } from 'store/types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { CheckmarkCircle24Regular, ErrorCircle24Regular, Warning24Regular } from '@fluentui/react-icons';

var calculation: boolean = false
var timeout: any;
const DialogContainer: React.FC<{}> = ({
}) => {

  const dispatch = useDispatch();
  const toggleDialog = useSelector((state: RootState) => state.ui.toggleDialog!)
  const type = useSelector((state: RootState) => state.ui.type!)
  const msg = useSelector((state: RootState) => state.ui.msg!)

  const [showDialog, setShowDialog] = useState(false)

  const toggle = (type: string, msg: string) => {
    dispatch(Action.toggleDialog({type, msg}))
  }

  useEffect(() => {
    if (msg !== "" && toggleDialog) {
      calculation = false
      setShowDialog(true)
      timeout = window.setTimeout(closeDialog, 1500)
    }
  }, [toggleDialog])


  const closeDialog = () => {
    clearTimeout(timeout)
    calculation = true
    setShowDialog(false);
    toggle("", "")
  }

  return showDialog ? (
    <div className={`${AppStyle["toast"]} ${AppStyle[type]}`} onClick={() => closeDialog()}>
      <div>
        <div>
          {type === 'alert' ? <ErrorCircle24Regular /> : type === 'warning' ? <Warning24Regular /> : type === 'success' ? <CheckmarkCircle24Regular /> : null}
        </div>
        <div>
          {msg}
        </div>
      </div>
    </div>
  ) : null
}

export default DialogContainer